import { useState } from "react";
import { Lock, Loader2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!email || !password) {
      toast.error("Please enter email and password.");
      return;
    }
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      localStorage.setItem("admin_token", data.token);
      localStorage.setItem("admin_name", data.name);
      toast.success("Welcome back!");
      navigate("/admin/dashboard");
    } catch (err) {
      const detail = err.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : "Login failed. Check your credentials.";
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#0A0A0B] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-14 h-14 rounded-sm bg-[#C5A059]/10 flex items-center justify-center mx-auto mb-4">
            <Lock className="w-7 h-7 text-[#C5A059]" />
          </div>
          <h1 className="font-heading text-2xl tracking-tight font-medium text-[#F3F4F6] mb-1">
            Admin Login
          </h1>
          <p className="text-sm text-[#71717A]">LUXGROOM Dashboard</p>
        </div>

        <form onSubmit={handleSubmit} className="p-8 rounded-md bg-[#141416] border border-white/5 space-y-5">
          <div>
            <label className="block text-sm text-[#A1A1AA] mb-2 font-medium">Email</label>
            <input
              data-testid="admin-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="ltaplett@luxgroom.net"
              className="w-full bg-white/5 border border-white/10 text-white focus:ring-1 focus:ring-[#C5A059] focus:border-[#C5A059] rounded-sm transition-all h-12 px-4 placeholder:text-[#71717A] outline-none"
            />
          </div>
          <div>
            <label className="block text-sm text-[#A1A1AA] mb-2 font-medium">Password</label>
            <input
              data-testid="admin-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              className="w-full bg-white/5 border border-white/10 text-white focus:ring-1 focus:ring-[#C5A059] focus:border-[#C5A059] rounded-sm transition-all h-12 px-4 placeholder:text-[#71717A] outline-none"
            />
          </div>
          <button
            data-testid="admin-login-btn"
            type="submit"
            disabled={loading}
            className="w-full bg-[#C5A059] text-black hover:bg-[#D4AF37] font-medium transition-all duration-300 rounded-sm px-8 py-4 text-sm uppercase tracking-wider disabled:opacity-50 flex items-center justify-center gap-2"
          >
            {loading ? <><Loader2 className="w-4 h-4 animate-spin" /> Signing in...</> : "Sign In"}
          </button>
          {error && (
            <p data-testid="admin-login-error" className="text-red-400 text-sm text-center mt-2">{error}</p>
          )}
        </form>
      </div>
    </div>
  );
}
